import { RpcError } from '@dealroadshow/json-rpc-dispatcher';

export const getTwoFactorViolationDataroomName = (error: RpcError): string => {
  const [{ dataroomName }] = error.getData() as unknown as { dataroomName: string }[];

  return dataroomName;
};
